/**
 * CRA inlines PUBLIC_URL at build time. It is empty for the default root-served build,
 * '/fieldsales' for the subpath build that NextGen's CloudFront fronts, and can be a full
 * origin when a build is served straight off a CDN. react-router's basename accepts only the
 * path part, so the origin is stripped here instead of at the call site.
 */
export const getBasename = (publicUrl) => {
  if (!publicUrl) {
    return '';
  }

  const path = publicUrl.replace(/^https?:\/\/[^/]+/i, '').replace(/\/+$/, '');
  if (!path) {
    return '';
  }

  return path.startsWith('/') ? path : `/${path}`;
};
